<template>
  <form style="position: relative">
    <div style="position:absolute; top: 10px; right: 10px;">
    <CopyBlock :sharedData="sharedData" />
    </div>
    <h2>{{ $t('Add.Image.Image') }}Block</h2>
    <div class="accordion-item">
      <div class="accordion-header" @click="toggleSection('main')">
        <span>{{ $t('Add.General.Main') }}</span>
        <span class="material-symbols-outlined">
          {{ isSectionActive('main') ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
        </span>
      </div>
      <div v-show="isSectionActive('main')" class="accordion-content">
    <div class="divider">
      <label class="contentLabel" for="imageUrl">{{ $t('Add.Image.ImageUrl') }}</label>
      <input type="text" id="imageUrl" v-model="sharedData.data.props.url" />
    </div>
   <!--  <div class="divider" v-if="!darkModeImage">
      <label class="contentLabel" for="imageUrl">{{ $t('Add.Image.DarkImageUrl') }}</label>
      <input type="text" id="imageUrl" v-model="sharedData.data.props.darkUrl" />
    </div> -->
    <div class="divider">
      <label class="contentLabel" for="altText">{{ $t('Add.Image.AltText') }}</label>
      <input type="text" id="altText" v-model="sharedData.data.props.alt" />
    </div>
    <div class="divider">
      <label class="contentLabel" for="linkUrl">{{ $t('Add.Image.LinkUrl') }}</label>
      <input type="text" id="linkUrl" v-model="url" />
    </div>
    <NameProp :sharedData="sharedData" />
    <ClassNamesProp :sharedData="sharedData" />
    </div>
    </div>
    <!-- Reiter: Style -->
    <div class="accordion-item">
      <div class="accordion-header" @click="toggleSection('style')">
        <span>{{ $t('Add.General.Style') }}</span>
        <span class="material-symbols-outlined">
          {{ isSectionActive('style') ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
        </span>
      </div>
      <div v-show="isSectionActive('style')" class="accordion-content">
    <div class="checkbox-container">
      <input
        class="checkBoxResize"
        type="checkbox"
        v-model="proportionalResize"
      />
      <label for="resize-checkbox">{{ $t('Add.Image.ProportionalResize') }}</label>
  </div>
  <div class="checkbox-container">
      <input
        class="checkBoxResize"
        type="checkbox"
        v-model="adjustToScreen"
      />
      <label for="resize-checkbox">{{ $t('Add.Image.AdjustToScreen') }}</label>
  </div>
    <div class="divider">
      <label class="contentLabel" for="width">{{ $t('Add.Image.Width') }}</label>
      <div class="range-container">
        <input type="range" min="1" max="600" v-model="width" class="slider" id="width" />
        <span>{{ Math.round(width) }} px</span>
      </div>
    </div>
    <div class="divider">
      <label class="contentLabel" for="height">{{ $t('Add.Image.Height') }}</label>
      <div class="range-container">
        <input type="range" min="1" max="400" v-model="height" class="slider" id="height" />
        <span>{{ Math.round(height) }} px</span>
      </div>
    </div>
    <div class="divider">
      <label class="contentLabel" for="scale">{{ $t('Add.Image.ScaleFromOrigin') }}</label>
      <div class="range-container">
        <input type="range" min="0.5" max="3" v-model="scale" class="slider" id="scale" step="0.25" />
        <span>{{ currentScale}}x</span>
      </div>
    </div>
    <BackgroundColorProp :sharedData="sharedData" />
    <div class="divider">
      <label class="contentLabel" for="borderColor">{{ $t('Add.Image.BorderColor') }}</label>
      <div class="color-container">
        <input type="color" id="borderColor" v-model="borderColor" />
        <span v-if="borderColor" class="material-symbols-outlined reset-color" @click="resetBorderColor">close</span>
        <div v-else class="add-color-overlay">+</div>
      </div>
    </div>
    </div>
    </div>
    <!-- Reiter: Positioning -->
    <div class="accordion-item">
      <div class="accordion-header" @click="toggleSection('positioning')">
        <span>{{ $t('Add.General.Positioning') }}</span>
        <span class="material-symbols-outlined">
          {{ isSectionActive('positioning') ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
        </span>
      </div>
      <div v-show="isSectionActive('positioning')" class="accordion-content">
    <div v-if="isParentRoot && false" class="divider">
      <p>Position</p>
      <div class="input-container">
        <label>
          <input type="radio" class="radios" name="textAlign" value="absolute" v-model="position" />
          <span class="radioSelect firstSelect">Absolute</span>
        </label>
        <label class="last">
          <input type="radio" class="radios" name="textAlign" value="static" v-model="position" />
          <span class="radioSelect lastSelect">Static</span>
        </label>
      </div>
    </div>
    <AlignmentProp :sharedData="sharedData" />
    <PaddingProp :sharedData="sharedData" />
    </div>
    </div>
  </form>
</template>

<script>
import { mapGetters } from 'vuex';
import PaddingProp from './AddProps/PaddingProp.vue';
import NameProp from './AddProps/NameProp.vue';
import ClassNamesProp from './AddProps/ClassNamesProp.vue';
import AlignmentProp from './AddProps/AlignmentProp.vue';
import CopyBlock from './AddProps/CopyBlock.vue';
import BackgroundColorProp from './AddProps/BackgroundColorProp.vue';
export default {
  name: 'AddImage',
  components: {
    PaddingProp,
    NameProp,
    ClassNamesProp,
    AlignmentProp,
    CopyBlock,
    BackgroundColorProp
  },
  props: ['sharedData'],
  data() {
    return {
      //activeSections: ['main'], // Default aktivierter Reiter
      currentScale: 1,
      initialSize: [],
      initialRatio: '',
      proportionalResize: false,
      darkModeImage: false,
    }
  },
  computed: {
    ...mapGetters(['getEmailData']),
    url: {
      get() {
        return this.sharedData?.data?.props?.link || '';
      },
      set(value) {
        if (!this.sharedData.data.props) this.sharedData.data.props = {};
        this.sharedData.data.props.link = value;
      },
    },
    height: {
      get() {
        return this.sharedData?.data?.props?.height || '';
      },
      set(value) {
        if (!this.sharedData.data.props) {
          this.sharedData.data.props = {};
        }
        if(this.proportionalResize == false) {
        this.sharedData.data.props.height = value;
        } else {
        this.sharedData.data.props.height = value;  
        this.sharedData.data.props.width = value * this.initialRatio;  
        }
      },
    },
    width: {
      get() {
        return this.sharedData?.data?.props?.width || '';
      },
      set(value) {
        if (!this.sharedData.data.props) {
          this.sharedData.data.props = {};
        }
        if(this.proportionalResize == false) {
        this.sharedData.data.props.width = value;
        } else {
        this.sharedData.data.props.width = value;  
        this.sharedData.data.props.height = value * (1/this.initialRatio);  
        }
      },
    },
    adjustToScreen:{
      get() {
        return this.sharedData?.data?.props?.width == null &&  this.sharedData?.data?.props?.height == null
      },
      set(value) {
        if(value){
        this.sharedData.data.props.width =  null;
        this.sharedData.data.props.height =  null;
        }
      },
    },
    scale: {
      get() {
        return this.currentScale
      },
      set(value) {
        this.sharedData.data.props.width =  this.initialSize[0] * value;
        this.sharedData.data.props.height =  this.initialSize[1] * value;
        this.currentScale = value
      },
    },
    position: {
      get() {
        return this.sharedData?.data?.style?.position || 'static';
      },
      set(value) {
        if (!this.sharedData.data.style) {
          this.sharedData.data.style = {};
        }
        this.sharedData.data.style.position = value;
      },
    },
    borderColor: {
      get() {
        return this.sharedData?.data?.style?.borderColor || null;
      },
      set(value) {
        if (!this.sharedData.data.style) this.sharedData.data.style = {};
        this.sharedData.data.style.borderColor = value;
      },
    },
    activeSections: {
      get() {
        return this.sharedData?.data?.props?.activeSections || ['main'];
      },
      set(value) {
        if (!this.sharedData.data.props) this.sharedData.data.props = {};
        this.sharedData.data.props.activeSections = value;
      },
    },
    isParentRoot(){
      const emailData = this.getEmailData
      console.log(emailData.root.data.childrenIds.indexOf(this.sharedData.id) > -1)
      console.log(this.sharedData)
 /*     if (emailData.root.data.childrenIds.indexOf(this.sharedData.id) > -1) {
        return true
      } else {
        return false
      } */
      return emailData.root.data.childrenIds.indexOf(this.sharedData.id) > -1
    } 

  },
  methods:{
    toggleSection(section) {
      if (this.activeSections.includes(section)) {
        // Wenn der Abschnitt bereits geöffnet ist, entferne ihn
        this.activeSections = this.activeSections.filter(s => s !== section);
      } else {
        // Abschnitt hinzufügen
        this.activeSections.push(section);
      }
    },
    isSectionActive(section) {
      return this.activeSections.includes(section);
    },
    resetBorderColor() {
      this.sharedData.data.style.borderColor = null;
    },
    updateImageSize() {
    const imageUrl = this.sharedData?.data?.props?.url || '';  
    if (!imageUrl) {
      return;
    }
    // Erstellen eines Image-Objekts, um die Bildgröße zu laden
    const img = new Image();
    img.onload = () => {
      // Wenn das Bild geladen ist, speichere die Breite und Höhe
      console.log(img.width, img.height)
      /* this.sharedData.data.props.height = img.height;
      this.sharedData.data.props.width = img.width;
      this.initialSize = [this.sharedData.data.props.width, this.sharedData.data.props.height]
      this.initialRatio = this.sharedData.data.props.width / this.sharedData.data.props.height */
      this.initialSize = [img.width, img.height]
      this.initialRatio = img.width / img.height;
    };
    // Bild laden
    img.src = imageUrl;
    
  }
  },
  watch: {
  // Überwacht Änderungen an der Bild-URL und ruft die Funktion zum Laden der Größe auf
  'sharedData.data.props.url': function(newValue) {
    this.updateImageSize();
  },
  'proportionalResize': function(newValue) {
    if (newValue === true) {
      this.sharedData.data.props.height = this.sharedData.data.props.width * (1/this.initialRatio);  
    }
  }
  },
  mounted(){
    if(this.sharedData.data.props.width && this.sharedData.data.props.height)
    this.initialSize = [this.sharedData.data.props.width, this.sharedData.data.props.height]
    this.initialRatio = this.sharedData.data.props.width / this.sharedData.data.props.height
  }
};
</script>
 <style scoped>
 @import '../../styles/addComponents.css';

 .checkbox-container {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  font-size: 14px;
}


input[type="checkbox"] {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  width: 18px;
  height: 18px;
  border: 1px solid #555; /* Randfarbe der Checkbox */
  border-radius: 3px;
  outline: none;
  cursor: pointer;
  margin-right: 15px;
}

input[type="checkbox"]:checked {
  background-color: var(--primary-color); /* Hintergrundfarbe der Checkbox, wenn sie angekreuzt ist */
  border-color: var(--primary-color);
}

input[type="checkbox"]:checked::before {
  content: "✔";
  display: block;
  color: white;
  font-size: 14px;
  text-align: center;
  line-height: 18px;
}

input[type="checkbox"]:hover {
  border-color: var(--primary-color); /* Randfarbe beim Hover-Effekt */
}

label {
  cursor: pointer;
}
 </style>